import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'

Vue.use(Vuex)
const myPrefix=()=>{
  //保存当前域名
  var myHost=location.protocol+'//' + location.host
  if (myHost.indexOf("localhost")>0){
    //本地时 图片前缀为
    myHost="https://www.kundagroup.com.au"
  }
  return myHost+"/kunda/"
}
const initPageState = () => {
  return {
    user: {
      // realname: '' || JSON.parse(localStorage.getItem('userCache')) ? JSON.parse(localStorage.getItem('userCache')).realname : '',
      // avatar: '' || JSON.parse(localStorage.getItem('userCache')) ? JSON.parse(localStorage.getItem('userCache')).avatar : '',
      // id: '' || JSON.parse(localStorage.getItem('userCache')) ? JSON.parse(localStorage.getItem('userCache')).id : ''
    },

    prefix: myPrefix(), // 正式环境

    language: localStorage.language || 1,
    IM: {
      username: (localStorage.IMinfo && JSON.parse(localStorage.IMinfo).username) || '',
      password: (localStorage.IMinfo && JSON.parse(localStorage.IMinfo).password) || ''
    },
    msgList: (localStorage.msgList && JSON.parse(localStorage.msgList)) || {},
    currentChatId: localStorage.currentChatId || '',
    status: '',
    formUrlEncoded: ''
  }
}
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: initPageState(),
  mutations: {

    [types.SAVE_USER](state, pageState) {
      for (const prop in pageState) {
        state.user[prop] = pageState[prop]
      }
    },
    setToken(state, token) {
      state.token = token
    },
    setContentType(state, type) {
      state.formUrlEncoded = type
    },
    setRole(state, role) {
      state.role = role
    },
    setRequisitionStatus(state, status) {
      console.log('status1111111', status)
      state.status = status
    },
    SAVE_LANG(state, lang) {
      state.language = lang
    },
    SET_IM(state, value) {
      for (const prop in value) {
        state.IM[prop] = value[prop]
      }
    },
    updateMsgList(state, msgList) {
      let signId = msgList.bySelf ? msgList.to : msgList.from
      if (!state.msgList[signId]) {
        state.msgList[signId] = []
        state.msgList[signId].push(msgList)
      } else {
        state.msgList[signId].push(msgList)
      }
      state.msgList = JSON.parse(JSON.stringify(state.msgList))
    },
    SAVE_CURRENT_CHAT_ID(state, id) {
      state.currentChatId = id
    },
    CHANGE_SLOT(state, id) {
      const key = id + ''
      if (state.msgList[key] && state.msgList[key].length > 0) {
        state.msgList[key].forEach(item => {
          item.unread = false
        })
      }
    },
    CLEAR_CURRENTCHAT_ID(state) {
      state.currentChatId = ''
    }
  },
  actions: {
    [types.SAVE_USER_CACHE]() {
      let user = this.state.user
      if (user.id !== '') {
        if (window.localStorage) {
          let ls = window.localStorage
          console.log('lsssssss', ls)
          let userCache = ls.getItem('userCache')
          if (userCache) {
            ls.removeItem('userCache')
          }
          ls.setItem('userCache', JSON.stringify(user))
        }
      }
    },
    [types.CLEAR_USER_CACHE]() {
      if (window.localStorage) {
        let ls = window.localStorage
        ls.removeItem('userCache')
      }
    },
    [types.GET_USER_CACHE]() {
      if (window.localStorage) {
        let ls = window.localStorage
        let userStr = ls.getItem('userCache')
        let user = JSON.parse(userStr)
        this.commit(types.SAVE_USER, {
          user: user
        })
      }
    },
    [types.GET_USER_EXIST]() {
      if (window.localStorage) {
        let ls = window.localStorage
        let userStr = ls.getItem('userCache')
        return !!userStr
      }
    },
    onLogin: function(context, payload) {
      context.commit('SET_IM', payload)
      var options = {
        user: payload.username,
        pwd: payload.password,
        appKey: WebIM.config.appkey
      }
      console.log(options)
      WebIM.conn.open(options) //登录
      localStorage.setItem('IMinfo', JSON.stringify({
        username: payload.username,
        password: payload.password
      }))
    },
    SAVE_MSGLIST_CACHE(context, payload) {
      let signId = payload.bySelf ? payload.to : payload.from
      let msgList = JSON.parse(localStorage.msgList)
      if (!msgList[signId]) {
        msgList[signId] = []
        msgList[signId].push(payload)
        localStorage.setItem('msgList', JSON.stringify(msgList))
      } else {
        msgList[signId].push(payload)
        localStorage.setItem('msgList', JSON.stringify(msgList))
      }
    },
    // 切换小红点的显示与隐藏（即修改）
    CHANGE_SLOT(context, payload) {
      // 同步vuex
      context.commit('CHANGE_SLOT', payload)
      // 修改缓存
      const key = payload + ''
      let msgList = JSON.parse(localStorage.msgList)
      if (msgList[key] && msgList[key].length > 0) {
        msgList[key].forEach(item => {
          if (item.unread) item.unread = false
        })
        localStorage.setItem('msgList', JSON.stringify(msgList))
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/framework/store/index.js